import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PartHeaderComponent } from '../parts/part-header/part-header.component';

@Component({
    selector: 'app-supplier',
    imports: [
        PartHeaderComponent
    ],
    templateUrl: './supplier.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './supplier.component.scss'
})
export class SupplierComponent {

}
